module.exports = __webpack_public_path__ + "img/zc_left.f96980cd.png";